<template>
    <div class="apps">
        <ui-button @click.native="open(ios)">
            <img src="@/assets/images/app-store.svg"/>
        </ui-button>

        <ui-button @click.native="open(android)">
            <img src="@/assets/images/google-play.svg"/>
        </ui-button>
    </div>
</template>

<script>
	import UiButton from "@/components/button/index.vue"

	export default {
		data () {
			return {
				android: "https://play.google.com/store/apps/details?id=com.tribuna.betting",
				ios: "https://itunes.apple.com/ru/app/sports-predictions/id1356073739"
			}
		},
        components: {
			UiButton
        },
		methods: {
			open (href) {
				console.log('href', href)
				window.open(href, '_blank')
			}
		}
	}
</script>

<style rel="stylesheet/stylus" lang="stylus" scoped>
    .apps {
        display flex
        flex-direction row
        justify-content center
        align-items center

        @media (max-width: 600px) {
            flex-direction column
        }

        >>> .ui-button {
            background-color #000
            border-radius 8px
            color #fff
            border-bottom 0
            padding 5px 0
            width 22rem
            height 6.8rem
            margin 2rem

            @media (max-width: 600px) {
                padding 0 .5rem
                width 12rem
                height 3.6rem
                margin 1rem
            }

            img {
                height 100%
                max-width 100%
                vertical-align top
            }
        }
    }
</style>
